import 'element-closest';
import initModules from '../initModules';

const NAV_SHOW_SPINNER = 'bfv-favorite-teaser-controller__content-spinner--show';

class BfvFavoriteController {

  constructor(options = {}) {
    this.$root = options.element;
    this.$spinner = this.$root.querySelector('.js-favorite-teaser-spinner');
    this.$contentWrapper = this.$root.querySelector('.js-bfv-favorite-teaser-content-wrapper');
  }

  init() {
    if (this.$root.dataset.apiRoute && !this.$contentWrapper.innerHTML.trim()) {
      this.loadContentFromApi(this.$root.dataset.apiRoute);
    } else {
      this.initAddRemoveBtns();
    }
  }

  /**
   * call api and insert response into root
   * @param apiUrl
   */
  loadContentFromApi(apiUrl) {
    if (this.$spinner) {
      if (this.$root.dataset.showSpinnerClass) {
        this.$spinner.classList.add(this.$root.dataset.showSpinnerClass);
      } else {
        this.$spinner.classList.add(NAV_SHOW_SPINNER);
      }
    }
    window.divae.restApi
      .loadData(apiUrl, 'application/xhtml+xml')
      .then((_response) => {
        this.$contentWrapper.innerHTML = _response;
        if (this.$spinner) {
          if (this.$root.dataset.showSpinnerClass) {
            this.$spinner.classList.remove(this.$root.dataset.showSpinnerClass);
          } else {
            this.$spinner.classList.remove(NAV_SHOW_SPINNER);
          }
        }
        initModules({ rootElement: this.$contentWrapper });
        this.initAddRemoveBtns();
      });
  }

  /**
   * Adds event listeners to favorite stars within the root
   * click event triggers api call which should handle the click and return a new content to display
   * if in a scrollable div checks to make sure that the scrollable isn't panning and mistakenly triggering a click
   */
  initAddRemoveBtns() {
    const $btnList = this.$contentWrapper.querySelectorAll('.js-favorite-star');
    const $scrollable = this.$contentWrapper.querySelector('.js-scrollable');
    $btnList.forEach((btn) => {
      if (btn.dataset.apiClick) {
        btn.addEventListener('click', (evt) => {
          evt.stopPropagation();
          if ($scrollable && $scrollable.lastHammerAction !== 'tap') {
            return;
          }
          this.$contentWrapper.innerHTML = '';
          this.loadContentFromApi(btn.dataset.apiClick);
        });
      }
    });
  }
}

export default BfvFavoriteController;



// WEBPACK FOOTER //
// ./src/javascript/main/BfvFavoriteController/index.js